import { MarketAccessory, MarketActionCard, MarketRow } from '@market/react';
import type { ComponentType } from 'react';
import {
  MarketBankIcon,
  MarketBitcoinIcon,
  MarketCardIcon,
  MarketFolderLockIcon,
  MarketLightningBoltIcon,
  MarketMoneyBagSignDollarIcon,
  type MarketIconProps,
} from '@squareup/market-react/icons';

import styles from './UpsellCard.module.css';

type MarketIconComponent = ComponentType<MarketIconProps>;

type UpsellIconName = 'bank' | 'bitcoin' | 'card' | 'folder-lock' | 'lightning-bolt' | 'money-bag-sign-dollar';

const ICON_MAP: Record<UpsellIconName, MarketIconComponent> = {
  bank: MarketBankIcon,
  bitcoin: MarketBitcoinIcon,
  card: MarketCardIcon,
  'folder-lock': MarketFolderLockIcon,
  'lightning-bolt': MarketLightningBoltIcon,
  'money-bag-sign-dollar': MarketMoneyBagSignDollarIcon,
};

export interface UpsellCardProps {
  readonly label: string;
  readonly iconName: UpsellIconName;
  readonly sublabel: string;
  readonly variant?: 'white' | 'gray';
  readonly onClick: () => void;
}

export const UpsellCard = ({
  label, iconName, sublabel, onClick, variant = 'white',
}: UpsellCardProps) => {
  const cardClass = variant === 'gray' ? styles.upsellCardGrayVariant : variant === 'white' ? styles.upsellCardWhiteVariant : '';
  const IconComponent = ICON_MAP[iconName];

  return (
    <MarketActionCard
      data-testid={`upsell-card-${label}`}
      className={cardClass}
      onClick={onClick}
    >
      <MarketRow variant="drill">
        <label slot="label">{label}</label>
        <p slot="subtext">{sublabel}</p>
        <MarketAccessory
          size="image"
          slot="leading-accessory"
        >
          {IconComponent && <IconComponent />}
        </MarketAccessory>
      </MarketRow>
    </MarketActionCard>
  );
};
